import { collectionEngineV1 } from '../apis';
const reqCollectors = collectionEngineV1('/collectors');
const reqCollectorsNotTenantScoped = collectionEngineV1('/collectors', false);
export const getAll = () => reqCollectors('GET', `/`, {
    cache: {
        name: 'collectors',
        duration: 1000 * 60 * 60 * 24,
    },
});
export const getBySiteBase = (siteBase) => reqCollectorsNotTenantScoped('GET', `/by-web-base/${siteBase}`, {
    cache: {
        name: 'collectors',
        duration: 1000 * 60 * 60 * 24,
    },
});
export const dnsSetup = (tenantId, collectorId) => reqCollectorsNotTenantScoped('GET', `/dns-setup/${tenantId}/${collectorId}`);
export const initiateDNS = (collectorId, dnsSetup) => reqCollectors('POST', `/initiate-dns/${collectorId}`, {
    body: dnsSetup,
});
export const update = (id, collector) => reqCollectors('PATCH', `/${id}`, { body: collector });
export const getById = (id, casualConsistency) => reqCollectors('GET', `/${id}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const create = (newCollector) => reqCollectors('POST', '/', {
    body: newCollector,
});
//# sourceMappingURL=collectors.js.map